import { render, staticRenderFns } from "./ImportExportSettings.vue?vue&type=template&id=723e4736"
import script from "./ImportExportSettings.vue?vue&type=script&lang=js"
export * from "./ImportExportSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports